import types from 'actions/types'
import Immutable from 'seamless-immutable'
import {get} from 'lodash'
import {combineReducers} from 'redux'
import {createPivotTableReducer} from 'reducers/pivotTable'
import {getPivotTableTotalReducer} from "helpers/pivotTable"

export const type = (state = Immutable(-1), action) => {
  switch (action.type) {
    case types.QUOTING_QUOTE_SELECTOR_UPDATE_FILTERS:
      return get(action, 'filters.type', state)
    default:
      return state
  }
}

export const creatorId = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_QUOTE_SELECTOR_UPDATE_FILTERS:
      return get(action, 'filters.creatorId', state)
    default:
      return state
  }
}

export const salesmanId = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_QUOTE_SELECTOR_UPDATE_FILTERS:
      return get(action, 'filters.salesmanId', state)
    default:
      return state
  }
}

export const estimatorId = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_QUOTE_SELECTOR_UPDATE_FILTERS:
      return get(action, 'filters.estimatorId', state)
    default:
      return state
  }
}

export const timeKey = (state = Immutable('custom:'), action) => {
  switch (action.type) {
    case types.QUOTING_QUOTE_SELECTOR_UPDATE_FILTERS:
      return get(action, 'filters.timeKey', state)
    default:
      return state
  }
}

export const allRevisions = (state = Immutable(false), action) => {
  switch (action.type) {
    case types.QUOTING_QUOTE_SELECTOR_UPDATE_FILTERS:
      return get(action, 'filters.allRevisions', state)
    default:
      return state
  }
}

export const selectedOrderId = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_QUOTE_SELECTOR_LOAD_ITEMS:
      return action.orderId
    case types.QUOTING_QUOTE_FINDER_SELECT_QUOTE:
      return action.orderId
    default:
      return state
  }
}

export const showLineItems = (state = false, action) => {
  switch (action.type) {
    case types.QUOTING_QUOTE_SELECTOR_TOGGLE_ITEMS:
      return action.showLineItems
    default:
      return state
  }
}

export const statusTypes = (state = [], action) => {
  switch (action.type) {
    case types.QUOTING_QUOTE_SELECTOR_UPDATE_FILTERS:
      return get(action, 'filters.statusTypes', state)
    default:
      return state
  }
}

export const companies = (state = [], action) => {
  switch (action.type) {
    case types.QUOTING_QUOTE_SELECTOR_UPDATE_FILTERS:
      return get(action, 'filters.companies', state)
    default:
      return state
  }
}

export const userTypes = (state = [], action) => {
  switch (action.type) {
    case types.QUOTING_QUOTE_SELECTOR_UPDATE_FILTERS:
      return get(action, 'filters.userTypes', state)
    default:
      return state
  }
}

export const contacts = (state = [], action) => {
  switch (action.type) {
    case types.QUOTING_QUOTE_SELECTOR_UPDATE_FILTERS:
      return get(action, 'filters.contacts', state)
    default:
      return state
  }
}

export const dateTypes = (state = [], action) => {
  switch (action.type) {
    case types.QUOTING_QUOTE_SELECTOR_UPDATE_FILTERS:
      return get(action, 'filters.dateTypes', state)
    default:
      return state
  }
}

export const targetStart = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_QUOTE_SELECTOR_UPDATE_FILTERS:
      return get(action, 'filters.targetStart', state)
    default:
      return state
  }
}

export const targetEnd = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_QUOTE_SELECTOR_UPDATE_FILTERS:
      return get(action, 'filters.targetEnd', state)
    default:
      return state
  }
}

export const orderTypeId = (state = [], action) => {
  switch (action.type) {
    case types.QUOTING_QUOTE_SELECTOR_UPDATE_FILTERS:
      return get(action, 'filters.orderTypeId', state)
    default:
      return state
  }
}

export const fixedStatusOptions = (state = null, action) => {
  switch (action.type) {
    case types.QUOTING_QUOTE_FINDER_INITIALISE_DIALOG:
      return action.statusOptions
    default:
      return state
  }
}

export const quotingContextSelectorOrdersPivotTableKey = 'quotingContext.selector.orders'
export const quotingContextSelectorOrderItemsPivotTableKey = 'quotingContext.selector.items'

const total = (state = null, action) => {
  return getPivotTableTotalReducer(state, action, quotingContextSelectorOrdersPivotTableKey)
}

export default combineReducers({
  orders: createPivotTableReducer({
    key: quotingContextSelectorOrdersPivotTableKey,
    defaultSortColumn: 'createdDate',
    defaultSortDirection: 'desc',
    pageSize: 50,
    defaultGridStretch: false,
    defaultAreAllRowsSelected: false,
    defaultCanSelectRows: false,
    retainEdits: false,
    onNewEntity: e => e,
    canSearch: true,
  }),
  items: createPivotTableReducer({
    key: quotingContextSelectorOrderItemsPivotTableKey,
    defaultSortColumn: Immutable('itemId'),
    defaultSortDirection: Immutable('asc'),
    pageSize: 100,
  }),
  type,
  creatorId,
  salesmanId,
  estimatorId,
  orderTypeId,
  timeKey,
  allRevisions,
  selectedOrderId,
  showLineItems,
  statusTypes,
  companies,
  userTypes,
  contacts,
  dateTypes,
  targetStart,
  targetEnd,
  total,
  fixedStatusOptions,
})
